const FETCH_ALTERNATIVES_REQUEST = 'FETCH_ALTERNATIVES_REQUEST'
const FETCH_ALTERNATIVES_SUCCESS = 'FETCH_ALTERNATIVES_SUCCESS'
const FETCH_ALTERNATIVES_FAILURE = 'FETCH_ALTERNATIVES_FAILURE'
const UPDATE_ALTERNATIVES = 'UPDATE_ALTERNATIVES'
export { FETCH_ALTERNATIVES_REQUEST, FETCH_ALTERNATIVES_SUCCESS, FETCH_ALTERNATIVES_FAILURE, UPDATE_ALTERNATIVES }
